
    var riot = require('riot')
    //src: starling/src/tags/menu/site-previewer-menu.html
riot.tag2('site-previwer-menu',
  '<ul class="floating-menu_list"> <li class="floating-menu_item" onclick="{toggleImage}"> <span class="floating-menu_label"> {this.isCollapsed() ? \'Show\' : \'Hide\'} image </span> </li> </ul>',
  '',
  'show="{isOpen}" class="floating-menu"', function(opts) {
'use strict';

var _this = this;

var _menuUi = require('lib/menu-ui');

var _nodesUi = require('lib/nodes-ui');

var _sitePreviewUi = require('lib/site-preview-ui');

var root = this.root;
var _opts = opts,
    canvas = _opts.canvas;

canvas.sitePreviewerMenu = this;

this.isOpen = false;
this.data = {};

this.summon = function (_ref) {
  var nodeTag = _ref.nodeTag,
      referenceEl = _ref.referenceEl,
      data = _ref.data;

  _this.isOpen = true;

  Object.assign(_this, { data: data, nodeTag: nodeTag });

  _menuUi.mui.positionSelf({
    selfEl: root,
    referenceEl: referenceEl
  });

  _this.update();
};

this.isCollapsed = function () {
  if (!_this.nodeTag) return true;

  return _sitePreviewUi.spUI.getLinkIsCollapsed({
    nodeId: _this.nodeTag.id,
    url: _this.data.url
  });
};

this.hide = function () {
  _this.isOpen = false;
  _this.nodeTag = null;
  _this.update();
};

this.toggleImage = function () {
  var data = _this.data,
      nodeTag = _this.nodeTag;
  var instance = nodeTag.instance;
  var url = data.url;

  _sitePreviewUi.spUI.setLinkIsCollapsed({
    nodeTag: nodeTag,
    url: url,
    isCollapsed: !_this.isCollapsed()
  });

  _this.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('site-previwer-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/site-previewer-menu.html
// module id = 741
// module chunks = 0